module.exports = __webpack_public_path__ + "fonts/UpheavalPro.5bc4d2e4.otf";